/* eslint-disable no-unused-vars */

/** ***********************************************
 * Angular Factory Service
 */

export default function appVersionInterceptor(
  $q,
  $rootScope,
  appVersionService,
) {
  console.log('app.interceptors.appVersionInterceptor created');

  return {
    response(res) {
      const versions = appVersionService.getVersions(res);
      appVersionService.notifyUserOnUpdate(versions, res.config.url);
      return res;
    },
    responseError(res) {
      const versions = appVersionService.getVersions(res);
      appVersionService.notifyUserOnUpdate(versions, res.config.url);
      return $q.reject(res);
    }
  };
}

appVersionInterceptor.$inject = [
  '$q',
  '$rootScope',
  'appVersionService',
];
